import { render, staticRenderFns } from "./ComputerSalesProgramForm.vue?vue&type=template&id=1844a902"
import script from "./ComputerSalesProgramForm.vue?vue&type=script&lang=js"
export * from "./ComputerSalesProgramForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports